module.exports = __webpack_public_path__ + "files/f86b6083a5dddb63df197f7464957bcd.svg";